module.exports = require('./helpers/bundle-url').getBundleURL('4BKs0') + "logo-dark.eefe0b7f.svg";